//import React from 'react';
import { useEffect } from 'react';
import Swal from 'sweetalert2';
import { useProfileScorecardFile } from '../../../hooks/useProfileScorecardFile';

const DownloadPdf = (props) => {
  const {
    isPending: loading,
    error,
    data
  } = useProfileScorecardFile(props.link, 'pdf');

  // Loding
  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: 'Generating your Profile Scorecard',
        allowEscapeKey: false,
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
    }
  }, [loading]);


  useEffect(() => {
    if (data && data.data) {
      Swal.fire({
        type: 'success',
        title: 'Done!',
        showConfirmButton: false,
        timer: 1500
      });
      
      const blob = data.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `profile-scorecard-${Date.now()}.pdf`; 
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      props.onSuccess();
    }
  }, [data, props]);


  if (error) {
    return `Error! ${error?.message || 'Unknown error'}`;
  }

  return null;
}

export default DownloadPdf
